import { Host, h } from "@stencil/core";
export class CoreNotificationPill {
    constructor() {
        this.number = undefined;
    }
    handleNumberChange(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.number = newValue;
        }
    }
    render() {
        const isNumberProps = this.number && this.number !== 'undefined' && typeof this.number !== 'undefined';
        return (h(Host, { key: 'e6a0982cda3aa62ae912b9b4bf8cf4e2d4c14874', class: `core-notification-pill typography-monoline-xsmall ${!isNumberProps ? 'notification-pill--empty' : ''}`, role: "status" }, h("span", { key: 'aaab4d9d9ba1fbbcd9f25d790f4935c818a715c6', class: "notification-pill-wrapper" }, isNumberProps && this.number)));
    }
    static get is() { return "core-notification-pill"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-notification-pill.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-notification-pill.css"]
        };
    }
    static get properties() {
        return {
            "number": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "number",
                "reflect": false,
                "defaultValue": "undefined"
            }
        };
    }
    static get watchers() {
        return [{
                "propName": "number",
                "methodName": "handleNumberChange"
            }];
    }
}
//# sourceMappingURL=core-notification-pill.js.map
